import React from 'react';
import { useContext } from "react";
import { Link } from "react-router-dom"
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { useIsAuthenticated } from "@azure/msal-react";
import { Language } from "../languages"
import { LanguageContext } from "../Helpers/Context";
import { SignInButton } from "./SignInButton";
import { SignOutButton } from "./SignOutButton";
import OfficeList from './OfficeList';

const useStyles = makeStyles((theme) => ({
  title: {
    flexGrow: 1,
  },
  left: {
    textAlign: 'left'
  },
  right: {
    textAlign: 'right'
  }
}));

export default function Header() {
  const isAuthenticated = useIsAuthenticated();
  const classes = useStyles();
  const { setLanguage, dictionary } = useContext(LanguageContext);

  return (
    <React.Fragment>
      <AppBar position='static'>
        <Toolbar>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={3}>
                <Typography variant="h6" color="inherit" noWrap className={classes.title} component={Link} to={'/'}>
                  {dictionary.title}
                </Typography>
            </Grid>
            <Grid item xs={1}>
                <Typography variant="h6" color="inherit" noWrap className={classes.title} >
                  |
                </Typography>
            </Grid>
            <Grid item xs={2}>
                <Typography variant="h6" color="inherit" noWrap className={classes.title} component={Link} to={'/efile'} >
                  EFILE Settings
                </Typography>
            </Grid>
            <Grid item xs={3} className={classes.right}>
              <Typography variant="subtitle1" color="inherit" noWrap>
                {dictionary.office}:
              </Typography>
            </Grid>
            <Grid item xs={1} className={classes.left}>
              {isAuthenticated ? <OfficeList></OfficeList> : <React.Fragment />}
            </Grid>
            <Grid item xs={2} >
              {isAuthenticated ? <SignOutButton /> : <SignInButton />}
            </Grid>
          </Grid>

          <ButtonGroup size="small" color="inherit" aria-label="outlined primary button group">
            <Button onClick={() => setLanguage(Language.English)}>En</Button>
            <Button onClick={() => setLanguage(Language.French)}>Fr</Button>
          </ButtonGroup>

        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
}

